import { Autocomplete, TextField, useTheme } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useController, useSuspense } from 'rest-hooks';
import { useScoreModel } from '../../../model/context/scoreModelContext';
import { ScoreModelResource } from '../../../model/resources/scoreModelResource';
import './scoreModelInput.css';

/**
 * Dropdown menu for selecting scoremodel
 */
export const ScoreModelInput = () => {
  const scoreModels = useSuspense(ScoreModelResource.list(), { includeHierarcy: true });
  const { scoreModel, switchScoreModel } = useScoreModel();
  const { invalidate } = useController();
  const options = [
    ...scoreModels.map((scoreModel) => ({
      label: scoreModel.name,
      value: scoreModel.scoreModelId
    }))
  ];
  const theme = useTheme();

  const changeSelectedScoreModel = (scoreModelId: number | undefined) => {
    invalidate(ScoreModelResource.detail(), { scoreModelId: scoreModelId });
    switchScoreModel(scoreModelId);
  };

  return (
    <Autocomplete
      options={options}
      disableClearable
      isOptionEqualToValue={(option, value) => option.value === value.value}
      popupIcon={<ExpandMoreIcon />}
      value={scoreModel ? { label: scoreModel.name, value: scoreModel.scoreModelId } : undefined}
      onChange={(_, option) => changeSelectedScoreModel(option?.value)}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={'Score model'}
          variant="standard"
          color="primary"
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            className: 'input',
            style: {...theme.typography.body2}
          }}
        />
      )}
    />
  );
};